import ReactGA from "react-ga";

export function initialize(trackingID,params) {
    ReactGA.initialize(trackingID,params);
    ReactGA.plugin.require('ecommerce');
}

export function pageView(path) {
    ReactGA.pageview(path || window.location.pathname);
}

export function modalview(path) {
    ReactGA.modalview(path);
}

export function event(params) {
  console.log(params);
  ReactGA.event({...params})
    /*category,action,value,label*/
}

export function set(params) {
    ReactGA.set(params);
    /*{ userId: 123 }*/
}

export function setEcommerceTransaction(payload){
    ReactGA.plugin.execute(
      'ecommerce',
      'addItem',
      {
        id: payload.id,
        name: payload.name,
        sku: '--', // seems to be required
        price: payload.revenue,
        category: payload.category,
        quantity: payload.quantity,
      }
    );
    ReactGA.plugin.execute(
      'ecommerce',
      'addTransaction',
      {
        id: payload.id, // the same as for addItem to connect them
        revenue: payload.revenue, // obviously it's price * quantity
      }
    );
    ReactGA.plugin.execute('ecommerce', 'send');
    ReactGA.plugin.execute('ecommerce', 'clear');
}


// WEBPACK FOOTER //
// ./src/components/reactGA/index.js